<template>
  <div class="flex items-center">
    <div>
      <img
        v-if="isCarrierRegistered"
        src="@/assets/highway-badge-gold.svg"
        alt="highway badge"
      />

      <svg
        v-else
        class="h-7 w-7"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4703 5.61133C16.8509 5.97523 15.9643 6.20383 14.9793 6.20383C13.9943 6.20383 13.1236 5.97944 12.5051 5.62141C11.8873 5.97944 11.0083 6.20383 10.0317 6.20383C9.0551 6.20383 8.15921 5.97523 7.54065 5.61133L4.6647 11.9364C4.38816 12.5435 4.24092 13.2015 4.23233 13.8686C4.22374 14.5357 4.354 15.1972 4.61482 15.8113C4.87564 16.4253 5.26132 16.9784 5.74736 17.4353C6.23341 17.8923 6.80919 18.2432 7.43812 18.4657L12.5034 20.2491L17.5686 18.4657C18.1983 18.244 18.7748 17.8937 19.2616 17.437C19.7485 16.9803 20.1349 16.4273 20.3963 15.8132C20.6578 15.199 20.7885 14.5371 20.7801 13.8697C20.7718 13.2022 20.6246 12.5438 20.3479 11.9364L17.4703 5.61133Z"
          fill="#C7CBDB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.20836 4.56818L7.9087 4.98019C8.39125 5.26409 9.15186 5.47129 10.0272 5.47129C10.9023 5.47129 11.6482 5.26832 12.1321 4.98787L12.4986 4.77545L12.8652 4.98766C13.3507 5.26863 14.0886 5.47129 14.9714 5.47129C15.8542 5.47129 16.606 5.26445 17.0902 4.97997L17.7902 4.56871L21.0019 11.6281C21.3205 12.3276 21.49 13.0857 21.4996 13.8541C21.5092 14.6226 21.3587 15.3847 21.0576 16.0919C20.7566 16.799 20.3117 17.4358 19.7512 17.9616C19.1906 18.4874 18.5268 18.8908 17.8019 19.146L12.4972 21.0137L7.19144 19.1456C6.46732 18.8895 5.8044 18.4855 5.24479 17.9593C4.68518 17.4332 4.24113 16.7964 3.94083 16.0895C3.64054 15.3825 3.49057 14.6208 3.50046 13.8528C3.51035 13.0849 3.6798 12.3275 3.99807 11.6286L7.20836 4.56818ZM17.0989 6.58157C16.4692 6.80988 15.7365 6.93406 14.9714 6.93406C14.0537 6.93406 13.1957 6.75848 12.4988 6.44177C11.8001 6.75871 10.9371 6.93406 10.0272 6.93406C9.26808 6.93406 8.53216 6.80992 7.89992 6.58126L5.32965 12.234C5.09534 12.7484 4.97039 13.3064 4.96311 13.8716C4.95583 14.4368 5.06619 14.9973 5.28718 15.5176C5.50817 16.0378 5.83495 16.5064 6.24676 16.8936C6.65858 17.2808 7.14642 17.5781 7.6793 17.7666L12.4972 19.4629L17.3161 17.7662C17.8495 17.5784 18.338 17.2816 18.7504 16.8947C19.1629 16.5078 19.4902 16.0393 19.7117 15.519C19.9332 14.9986 20.044 14.4379 20.0369 13.8724C20.0299 13.3069 19.9052 12.7491 19.6707 12.2345L17.0989 6.58157Z"
          fill="#A9ADBD"
        />
        <path
          d="M14.0822 15.5162H17.612L14.9873 8.99786H13.2191L13.5275 11.3275H11.4727L11.7811 8.99786H10.0128L7.38818 15.5162H10.918L11.2264 13.1874H13.7738L14.0822 15.5162Z"
          fill="#ffffff"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Highway Connect Badge',
  components: {},
  props: {
    isCarrierRegistered: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {};
  },
};
</script>
